/**
 * @Author: zangkang
 * @Date:   2018-02-05T10:46:26+08:00
 * @Last modified by:   Zewei
 * @Last modified time: 2018-02-05T10:46:26+08:00
 */

import React from 'react';
import { connect } from 'react-redux';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { Table,
	Button,
	Modal,
	Spin,
	message,
	Icon,
	Divider,
	Input,
	InputNumber,
	Form,
	DatePicker,
	Select } from 'antd';
import moment from 'moment';
import { fetchCertificateList,
	deleteCertificate,
	updateCertificate,
	createCertificate,
	changeCertificateValue,
	CertificatePost,
fetchEmployeesList,
	initContarctAlert, fetchEmployeeInit } from '../../actions/employee-management-actions.js';
import './style.less';
import certificateManageService from '../../services/EmployeeManagement/certificate-manage-service.js';

class CertificateManagement extends React.Component {
  state = {page: 1, order_property:"", is_order_asc:true};
	rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			let ids = selectedRows.map(row => row.id);
			this.setState({selectedIDs: ids});
		}
	};
	componentWillMount() {
		this.props.fetchCertificateList(this.state);
		this.props.fetchEmployeeInit()
	}
	componentWillReceiveProps(nextProps) {
		console.log(nextProps);
	}
	pageCertificateList(pagination, filters, sorter) {
    let gets = {};
    this.setState({page: pagination.current, order_property:sorter.field, is_order_asc:sorter.order==='ascend' ? true : false}, () => {
      for (let key in this.state) {
        if (this.state[key] !== undefined) {
          gets[key] = this.state[key];
        }
      }
    });

    this.props.fetchCertificateList(gets)
	}
	openCertificateModal() {
		let currentCertificate = {
			name: null,
			type: '身份证',
			employee_id:null,
			serial_number: null,
			issuing_organ: null,
			issuing_date: null,
			expire_date: null,
			employee_name: '',
			employee_phone: null,

			created_time: null,
			record_date: null,
			reminder_date: null,
			specialty: null,
			c_level: null,
			description: null
		}
		this.setState({currentCertificate: currentCertificate});
	}
	closeCertificateModal() {
		this.setState({currentCertificate: null});
	}
	multiDeleteCertificateModal() {
		if (!this.state.selectedIDs || this.state.selectedIDs.length === 0) {
			message.error('请选择证件', 4);
			return;
		}
		Modal.confirm({
			title: '确定删除?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				this.props.deleteCertificate({ids: this.state.selectedIDs}, status => {
					if (status) {
						this.props.fetchCertificateList(this.state);
					}
				});
			},
			onCancel: () => {}
		});
	}
	importCertificateModal() {
		this.setState({importModal: true});
	}
	closeImportCertificateModal() {
		this.setState({importModal: false});		
	}
	exportCertificateModal() {
  	let ref = Modal.info({content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"});	
		certificateManageService.exportCertificate(res => {
  		ref.destroy();
  		if (res.data.Success) {
  			window.open(res.data.Message);
  		}else{
  			message.error('下载失败', 4);
  		}
		}, err => {
  		ref.destroy();
  		message.error('下载失败', 4);
		});
	}
	// closeExportCertificateModal() {
	// 	this.setState({exportModal: false});			
	// }
	alarmCertificateModal() {
		this.setState({alarmModal: true});
		this.props.initContarctAlert();
	}
	closeAlarmCertificateModal () {
		this.setState({alarmModal: false});		
	}
	handleSubmit(event) {
   	this.props.form.validateFields((err, values) => {
      if (!err) {
      	// console.log(values);
		['expire_date', 'issuing_date', 'created_time', 'record_date', 'reminder_date'].forEach(date => {
			if (values[date]) {
				values[date] = values[date].format('YYYY-MM-DD');
			}
		});
		values.employee_id = this.state.currentCertificate.employee_id;
      	if (this.state.currentCertificate.id) {
      		values.id = this.state.currentCertificate.id
      		values.type_name = this.state.currentCertificateName ? this.state.currentCertificateName : this.state.currentCertificate.type_name;
      		values.employee_id = this.state.currentCertificate.employee_id;
      		values.employee_phone = this.state.currentCertificate.employee_phone;

      		this.props.updateCertificate(values, this.state.currentIndex, status => {
      			this.setState({currentCertificate: null});
      			this.props.fetchCertificateList(this.state);
      		});
      	}else{
      		this.props.createCertificate(values, status => {
      			if (status) {
      				this.setState({currentCertificate: null});
							this.props.fetchCertificateList(this.state);
      			}
      		});
      	}
      }
    });
	}
	updateCertification(index) {
		this.setState({currentIndex: index});
		this.setState({currentCertificate: this.props.employeeManagement.certificateList[index]});
	}
	changeCertificateOverAlert(value) {
		this.props.changeCertificateValue(value);
	}
	submitAlarmCertificate() {
		this.props.CertificatePost({certificate_over_alert: this.props.employeeManagement.certificate_over_alert});
		this.setState({alarmModal: false});
	}
	changeEmployee(value) {
		let param = {
			real_name: value
		}
		this.props.fetchEmployeesList(param);
	}
	selectEmployee(id, obj) {
		let copyCurrentCertificate = {...this.state.currentCertificate};
		copyCurrentCertificate.employee_id = obj.props.data;
		copyCurrentCertificate.employee_name = obj.props.children;
		this.setState({currentCertificate: copyCurrentCertificate});
	}
	downloadTemplate = () => {
		let ref = Modal.info({content: "正在准备需要下载的模板"});
		certificateManageService.downloadTemplate(res => {
  		ref.destroy();
			if (res.data.Success) {
				window.open(res.data.Message);
			}
		});
	}
	selectCertificate = (certificateID, object) => {
		console.log(object.props.data);
		this.setState({currentCertificateName: object.props.data});
	}

	setUploadedFile = event => {
		this.setState({uploadedFile: event.target.files[0]});
	}

	importCertificate = () => {
		if (this.state.uploadedFile) {
			let ref = Modal.info({content: "正在导入文件, 请稍后..."});
			let formData = new FormData();
			formData.append("uploadedFile", this.state.uploadedFile);
			certificateManageService.importCertificate(formData, res => {
				ref.destroy();
				if(res.data.Success) {
					message.success('导入文件成功', 4);
					this.setState({importModal: false});
					this.props.fetchCertificateList(this.state);
					if(res.data.Object){
						window.open(res.data.Object);
					}
				}else{
					message.error("导入文件失败, " + res.data.Errors[0], 4)
				}
			},err => message.error("导入文件失败", 4));	
		}else{
			message.error("请选择需要导入的文件", 4);
		}
	}
	render() {
		const { employeeCreateInit } = this.props.employeeManagement;
		const columns = [
            {title: '持证人',			dataIndex: 'employee_name', className: 'certificate-head-class'},
			{title: '证件名称',			dataIndex: 'name', className: 'certificate-head-class'},
			{title: '证件类型',			dataIndex: 'type_name', className: 'certificate-head-class'},
			{title: '证件编号',			dataIndex: 'serial_number', className: 'certificate-head-class', sorter: true},
			{title: '发证机构',			dataIndex: 'issuing_organ', className: 'certificate-head-class'},
			{title: '发证日期',			dataIndex: 'issuing_date', className: 'certificate-head-class', sorter: true},
			{title: '到期日期',			dataIndex: 'expire_date', className: 'certificate-head-class', sorter: true},
			{title: '持证人手机号',	    dataIndex: 'employee_phone', className: 'certificate-head-class'},
			{title: '操作',					dataIndex: 'action', className: 'certificate-head-class', render: (text, record, index) => this.props.access.certificateManagement.u_value &&
				<span title="编辑" onClick={this.updateCertification.bind(this, index)}>
					<Button icon="edit" size="small" className="row-action-btn">编辑</Button>
				</span>
			}
		];
		return (
			<div className="app-module-item">
				<div className="colAction">
					{this.props.access.certificateManagement.c_value && <span><Button type="primary" onClick={this.openCertificateModal.bind(this)}>
						<Icon type="plus" />
						<span>新增</span>
					</Button>
					<Divider type="vertical" /></span>}
					{this.props.access.certificateManagement.d_value && <span><Button type="primary" onClick={this.multiDeleteCertificateModal.bind(this)}>
						<Icon type="delete" />
						<span>删除</span>
					</Button>
					<Divider type="vertical" /></span>}
					{this.props.access.certificateManagement.import_value && <span><Button type="primary" onClick={this.importCertificateModal.bind(this)}>
						<Icon type="cloud-upload-o" />
						<span>导入</span>
					</Button>
					<Divider type="vertical" /></span>}
					{this.props.access.certificateManagement.export_value && <span><Button type="primary" onClick={this.exportCertificateModal.bind(this)}>
						<Icon type="cloud-download-o" />
						<span>导出</span>
					</Button>
					<Divider type="vertical" /></span>}
					{this.props.access.certificateManagement.set_value && <Button type="primary" onClick={this.alarmCertificateModal.bind(this)}>
						<Icon type="setting" />
						<span>预警设置</span>
					</Button>}
				</div>
				<Modal width="1000px"
					visible={!!this.state.currentCertificate}
					title="新增证件"
					destroyOnClose={true}
					onCancel={this.closeCertificateModal.bind(this)}
					onOk={this.handleSubmit.bind(this)}>
					<div style={{textAlign:"center",height:"540px",overflow:"auto"}}>
						<Form onSubmit={this.handleSubmit.bind(this)} className="login-form" layout="inline" >
                            <div className="position-form-item">
                                <Form.Item label="持证人">
                                        {this.props.form.getFieldDecorator('employee_name', {
                                            rules: [{ required: true, message: '请输入持证人' }],
                                            initialValue: this.state.currentCertificate && this.state.currentCertificate.employee_name
                                        })( <Select mode="combobox"
                                    style={{ width: 400 }}
                                    onChange={this.changeEmployee.bind(this)}
                                    filterOption={false}
                                    placeholder="请输入持证人姓名"
                                    onSelect={this.selectEmployee.bind(this)}
                                >
                                    {this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
                                    this.props.employeeManagement.employeeList.Data.map(employee => {
                                        return (<Select.Option key={employee.id} value={employee.real_name} data={employee.id}>{employee.real_name}</Select.Option>)
                                    })}
                                </Select>)}
                                </Form.Item>
                            </div>
							<div className="position-form-item">
								<Form.Item label="证件名称">
									{this.props.form.getFieldDecorator('name', {
										rules: [{ required: true, message: '请输入证件名称' }],
										initialValue: this.state.currentCertificate && this.state.currentCertificate.name
									})(<Input placeholder="证件名称" style={{width:"400px"}} />)}
								</Form.Item>
							</div>
							<div className="position-form-item">
							{/*<Select style={{width:"400px"}} onSelect={this.selectCertificate}>
										<Select.Option key={1} value={1} data="身份证">身份证</Select.Option>
										<Select.Option key={2} value={2} data="护照">护照</Select.Option>
									</Select>*/}
								<Form.Item label="证件类型">
									{this.props.form.getFieldDecorator('type_id', {
										rules: [{ required: true, message: '请选择证件类型' }],
										initialValue: this.state.currentCertificate && this.state.currentCertificate.type_id
									})(
									
									<Select style={{width:"400px"}}>
                                            {
                                                employeeCreateInit ?
                                                    employeeCreateInit.id_types.map( item => (<Select.Option key={item.Value} value={item.Value}>{item.Text}</Select.Option>))
                                                    :
                                                    ''
                                            }
                                        </Select>
									)}
								</Form.Item>
							</div>
							<div className="position-form-item">
								<Form.Item label="证件编号">
									{this.props.form.getFieldDecorator('serial_number', {
										rules: [{ required: true, message: '请输入证件编号' }],
										initialValue: this.state.currentCertificate && this.state.currentCertificate.serial_number
									})(<Input placeholder="证件编号" style={{width:"400px"}} />)}
								</Form.Item>
							</div>
							<div className="position-form-item" style={{paddingLeft:"11px"}}>
								<Form.Item label="发证机构">
									{this.props.form.getFieldDecorator('issuing_organ', {
										rules: [],
										initialValue: this.state.currentCertificate && this.state.currentCertificate.issuing_organ
									})(<Input placeholder="发证机构" style={{width:"400px"}} />)}
								</Form.Item>
							</div>
							<div className="position-form-item">
								<Form.Item label="发证日期">
									{this.props.form.getFieldDecorator('issuing_date', {
										rules: [{ required: true, message: '请输入发证日期' }],
										initialValue: (this.state.currentCertificate && this.state.currentCertificate.issuing_date) ?
											moment(this.state.currentCertificate.issuing_date) : null
									})(<DatePicker placeholder="发证日期" style={{width:"400px"}} />)}
								</Form.Item>
							</div>
							<div className="position-form-item" style={{paddingLeft:"11px"}}>
								<Form.Item label="备案日期">
									{this.props.form.getFieldDecorator('record_date', {
										rules: [],
										initialValue: (this.state.currentCertificate && this.state.currentCertificate.record_date) ?
											moment(this.state.currentCertificate.record_date) : null
									})(<DatePicker placeholder="备案日期" style={{width:"400px"}} />)}
								</Form.Item>
							</div>
{/*							<div className="position-form-item" style={{paddingLeft:"11px"}}>
								<Form.Item label="提醒日期">
									{this.props.form.getFieldDecorator('reminder_date', {
										rules: [],
										initialValue: (this.state.currentCertificate && this.state.currentCertificate.reminder_date) ?
											moment(this.state.currentCertificate.reminder_date) : null
									})(<DatePicker placeholder="提醒日期" style={{width:"400px"}} />)}
								</Form.Item>
							</div>*/}
							<div className="position-form-item" style={{paddingLeft:"11px"}}>
								<Form.Item label="到期日期">
									{this.props.form.getFieldDecorator('expire_date', {
										rules: [],
										initialValue: (this.state.currentCertificate && this.state.currentCertificate.expire_date) ?
											moment(this.state.currentCertificate.expire_date) : null
									})(<DatePicker placeholder="到期日期" style={{width:"400px"}} />)}
								</Form.Item>
							</div>
							<div className="position-form-item" style={{paddingLeft:"37px"}}>
								<Form.Item label="专业">
									{this.props.form.getFieldDecorator('specialty', {
										rules: [],
										initialValue: this.state.currentCertificate && this.state.currentCertificate.specialty
									})(<Input placeholder="专业" style={{width:"400px"}} />)}
								</Form.Item>
							</div>
							<div className="position-form-item" style={{paddingLeft:"37px"}}>
								<Form.Item label="级别">
									{this.props.form.getFieldDecorator('c_level', {
										rules: [],
										initialValue: this.state.currentCertificate && this.state.currentCertificate.c_level
									})(<Input placeholder="级别" style={{width:"400px"}} />)}
								</Form.Item>
							</div>
							<div className="position-form-item" style={{paddingLeft:"37px"}}>
								<Form.Item label="描述">
									{this.props.form.getFieldDecorator('description', {
										rules: [],
										initialValue: this.state.currentCertificate && this.state.currentCertificate.description
									})(<Input.TextArea style={{width:"400px"}} rows="5"></Input.TextArea>)}
								</Form.Item>
							</div>
						</Form>
					</div>
				</Modal>
				<Modal width="800px"
					visible={!!this.state.importModal}
					title="导入证件"
					destroyOnClose={true}
					onCancel={this.closeImportCertificateModal.bind(this)}
					footer={<Button type="back" onClick={this.closeImportCertificateModal.bind(this)}>关闭</Button>}>
					<div style={{textAlign:"center",margin:"20px 0px 20px"}}>
						<div>
							<Button type="primary" onClick={this.downloadTemplate}>
								<Icon type="cloud-download-o" />
								<span>下载模板</span>
							</Button>
						</div>
						<div style={{marginTop:"40px"}}>
							<div>导入文件</div>
							<Input type="file" style={{height:"38px"}} onChange={this.setUploadedFile} />
							<Button type="primary" style={{marginTop:"20px"}} onClick={this.importCertificate}>
								<Icon type="cloud-upload-o" />
								<span>开始导入</span>
							</Button>
						</div>
					</div>
				</Modal>
{/*				<Modal width="800px"
					visible={!!this.state.exportModal}
					title="导出证件"
					destroyOnClose={true}
					onCancel={this.closeExportCertificateModal.bind(this)}
					footer={<Button type="back" onClick={this.closeExportCertificateModal.bind(this)}>关闭</Button>}>
					<div style={{textAlign:"center",margin:"20px 0px 20px"}}>
					</div>
				</Modal>*/}
				<Modal width="800px"
					visible={!!this.state.alarmModal}
					title="证件到期提醒"
					destroyOnClose={true}
					onCancel={this.closeAlarmCertificateModal.bind(this)}
					onOk={this.submitAlarmCertificate.bind(this)}>
					<div style={{textAlign:"center",margin:"20px 0px 20px"}}>
						<div style={{margin:"15px"}}>
							<span>证件到期预警通知: 提前</span>
							<InputNumber min={1} step={1} style={{margin:"0px 10px"}} ref="contract_over_alert"
								onChange={this.changeCertificateOverAlert.bind(this)}
								value={this.props.employeeManagement.certificate_over_alert} />
							<span>天预警</span>
						</div>
					</div>
				</Modal>
				{ this.props.employeeManagement.certificateList ?
				<Table rowSelection={this.rowSelection} columns={columns}
					dataSource={this.props.employeeManagement.certificateList}
					rowKey={record => record.id}
					scroll={{x: 600}}
					pagination={{
						total: this.props.employeeManagement.certificateTotal,
						pageSize:this.props.employeeManagement.certificatePageSize,
                        current: this.props.employeeManagement.certificatePage,  
						defaultCurrent: 1}}
					onChange={this.pageCertificateList.bind(this)} />
				: <div style={{textAlign:'center', margin: '100px 0px'}}><Spin size="large" /></div> }
			</div>
		)
	}
}
CertificateManagement = Form.create()(CertificateManagement);

const mapStateToProps = state => {
	return {
		employeeManagement: state.employeeManagement
	}
}

const mapDispatchToProps = {
	fetchCertificateList,
	createCertificate,
	deleteCertificate,
	updateCertificate,
	initContarctAlert,
	changeCertificateValue,
	CertificatePost,
	fetchEmployeesList,
	fetchEmployeeInit
}


export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(CertificateManagement));


// WEBPACK FOOTER //
// ./src/routes/EmployeeManagement/CertificateManagement.js